import axios from "@/plugins/axios";
import store from "@/store";

export default {
  // ,var tasksUrl = configuration.tasksUrl;
  get(taskId) {
    return axios.httpTask.get("/task/" + taskId);
  },
  getMany(tasksIds) {
    return axios.httpTask.post("/task/check-bulk",{'tasks_ids':tasksIds});
  },
  strategySimulate(strategy, useCache) {
    let url = "/tasks/simulate";
    let data = {};
    if (typeof strategy === "number") {
      url = "/tasks/" + strategy + "/simulate";
    } else {
      data = strategy;
    }
    data['use_cache'] = useCache
    return axios.httpApi.post(url, data);
  },
  
  strategiesSimulate(strategiesIds, useCache) {
    let url = "/tasks/simulate";
    return axios.httpApi.post(url, { strategiesIds, use_cache: useCache});
  },
  
  strategyFire(strategyId, smsGateway, emailGateway, useBaits) {
    useBaits = useBaits === undefined ? false : useBaits;
    var url = "/tasks/" + strategyId + "/fire?use_baits=" + useBaits;
    if (smsGateway) url += "&sms_gateway=" + smsGateway;
    if (emailGateway) url += "&email_gateway=" + emailGateway;

    let currentUser = store.getters.getLoggedUser
    if (!currentUser) currentUser = {}
    return axios.httpApi.post(url, { currentUserName: currentUser.name });
  },
  
  strategiesFire(strategiesIds, smsGateway, emailGateway, useBaits) {
    useBaits = useBaits === undefined ? false : useBaits;
    let url = `/tasks/fire?use_baits=${useBaits}`;
    if (smsGateway) url += "&sms_gateway=" + smsGateway;
    if (emailGateway) url += "&email_gateway=" + emailGateway;
    
    let currentUser = store.getters.getLoggedUser
    if (!currentUser) currentUser = {}

    return axios.httpApi.post(url, { strategiesIds, currentUserName: currentUser.name });
  },

  async revoke(taskId) {
    return await axios.httpTask.get(`/task/${taskId}/revoke`);
  },

  async revokeMany(tasks_ids) {
    return axios.httpTask.post(`/task/revoke`,{tasks_ids});
  },

};




